var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"disabled":!!_vm.disabledReason,"tooltip":_vm.tooltip,"expand-on-hover":false,"label":"Reembolsar","icon-src":_vm.refundIcon},on:{"click":function($event){return _vm.$emit('refund', _vm.charge)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }